import { render, staticRenderFns } from "./AdministrationSectionHeader.vue?vue&type=template&id=6a75afc6&scoped=true&lang=html&"
import script from "./AdministrationSectionHeader.vue?vue&type=script&lang=js&"
export * from "./AdministrationSectionHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a75afc6",
  null
  
)

export default component.exports